import { DomainConfig } from '@domgen/dgx-fe-config';
import { Environment } from './environment.model';
import { RuntimeConfig } from './runtime-config.model';

export type AppConfig = Environment & RuntimeConfig & DomainConfig;
